import React from 'react';
import Nav from './Nav';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../../Components/Containers/ErrorBoundary/ErrorBoundary';
import DialoguesWrapper from '../../Components/Dialogues';
import HelpWrapper from '../../Components/Help';
import Mobile from '../../Components/Mobile';
import Assistant, { Panel } from '../../Components/Assistant';
import Analytics from '../../Components/Analytics';

export default () => {

    return <div className="flex flex-row bg-blue-50 justify-center">
        <DialoguesWrapper>
            <HelpWrapper>
                <Assistant>
                    <Mobile>
                        <Nav />

                        <div className="shrink page-container min-h-screen pt-[0.5rem] pr-[0.5rem] flex flex-col">
                            <div className="w-full h-full rounded-xl overflow-hidden bg-white shadow-lg"
                                style={{height: 'calc(100% - 1rem)'}}
                            >
                                <div className="relative grow">
                                    <ErrorBoundary>
                                        <Outlet />
                                    </ErrorBoundary>
                                </div>
                                <div className="shrink">
                                    <ErrorBoundary>
                                        <Panel />
                                    </ErrorBoundary>
                                </div>
                            </div>
                        </div>
                    </Mobile>
                </Assistant>
            </HelpWrapper>
        </DialoguesWrapper>
        <Analytics />
    </div>
}
